import React, { useRef, useState, useEffect, useLayoutEffect} from 'react';

// Importar iconos
import icono1 from '../assets/maquinaria/iconos/1.medalla_icono_1.png';
import icono2 from '../assets/maquinaria/iconos/2.brocha_1.png';
import icono3 from '../assets/maquinaria/iconos/3.camion_carga_1.png';
import icono4 from '../assets/maquinaria/iconos/4.engranajes_ajustando_1.png';
import iconoLista from '../assets/iconos/etiquetaBullet.png';
//Version escritorio
import proceso1 from '../assets/maquinaria/1ImpresionFlexografica.png';
import proceso2 from '../assets/maquinaria/2ImpresionDigitalHibrida.png';
import proceso3 from '../assets/maquinaria/3MangasTermoencogibles.png';
import proceso4 from '../assets/maquinaria/4IML.png';
import proceso5 from '../assets/maquinaria/5Termoformadora.png';
//Version mobile
import mobileProceso1 from '../assets/maquinaria/mobile/ImpresionFlexografica.png';
import mobileProceso2 from '../assets/maquinaria/mobile/ImpresionDigitalHibrida.png';
import mobileProceso3 from '../assets/maquinaria/mobile/MangasTermoencogibles.png';
import mobileProceso4 from '../assets/maquinaria/mobile/IML.png';
import mobileProceso5 from '../assets/maquinaria/mobile/Termoformadora.png';

//Contenido de maquinarias
const maquinas = [
    {
      id: 1,
      nombre: 'Impresión Flexográfica:',
      nombredesc:'Alta precisión para grandes volúmenes',
      icono: '',
      descripcion: '',
      txt1descripcion: [
        [<strong>Ideal para producir tirajes grandes a gran velocidad y con acabados especiales.</strong>, ' Nuestra flexografía de hasta 8 colores ofrece calidad cromática y control total en tirajes grandes.'],
      ],
      txt2descripcion:'',
      enlistado:'Perfecto si lo que buscas es:',
      caracteristicas: [
        [<strong>Hasta 8 estaciones de color </strong>,'para máxima fidelidad.'], 
        [<strong>Acabados premium:</strong>, '  barnices, laminados, cold foil.'], 
        [<strong>Velocidad óptima</strong>, ' para cumplir con tiempos de entrega reducidos.'],
        [<strong>Cumplir estándares internacionales</strong>, ' de calidad.'],
      ],
      img: proceso1,
      imgmobile: mobileProceso1
    },
    {
      id: 2,
      nombre: 'Impresión Digital Híbrida:',
      nombredesc:'Personalización sin límites',
      icono: '',
      descripcion: '',
      txt1descripcion:[
        [' Combina lo mejor de dos mundos: ',<strong>la flexibilidad digital en diseños + acabados de flexo e impresión en línea.</strong>,' Perfecta para pedidos variables y personalización masiva, manteniendo tiempos de respuesta rápidos.'],
      ],
      txt2descripcion:'',
      enlistado:'Lo que lo hace especial:',
      caracteristicas: [
        [<strong>7 estaciones digitales + 2 flexo. </strong>], 
        [<strong>Personalización </strong>, 'acorde a sus necesidades.'], 
        ['Acabados en línea: barnices, tintas especiales, fondos blancos.'],
      ],
      img: proceso2,
      imgmobile: mobileProceso2
    },
    {
      id: 3,
      nombre: 'Formado y Corte de Mangas Termoencogibles:',
      nombredesc:'Ajuste perfecto en cada envase',
      icono: '',
      descripcion: '',
      txt1descripcion:[
        ['Convierte tu envase en un lienzo de 360° con una etiqueta que adopte su forma. Precisión de corte y armado para tener una presentación final impecable.'],
      ],
      txt2descripcion:'',
      enlistado:'Ventajas para tu producto:',
      caracteristicas: [
        ['Corte ', <strong>automatizado y preciso.</strong>], 
        ['Listas para aplicación.'], 
        [<strong>Menos desperdicio,</strong>, ' más eficiencia.'],
        ['Adaptables para envases cilíndricos o con diseños complejos y únicos.'],
      ],
      img: proceso3,
      imgmobile: mobileProceso3
    },
    {
      id: 4,
      nombre: 'In-Mold Labeling (IML):',
      nombredesc:'Control total',
      icono: '',
      descripcion: '',
      txt1descripcion:[
        [<strong>Esto no es un vaso. Es una etiqueta hecha vaso.</strong>, ' Así, vaso y etiqueta son uno mismo, lo que nos permite cuidar cada detalle en el material y acabado, además de tener un producto de gran durabilidad. Al ser una etiqueta de origen, puedes personalizar todo lo que necesites.'],
      ],
      txt2descripcion:'',
      enlistado:'Ventajas clave:',
      caracteristicas: [
        ['Acabado premium, más durable que una etiqueta adhesiva.'], 
        ['Moldes de 24 oz para bebidas calientes y de 32 oz para bebidas frías.'], 
        ['Polipropileno (PP) ', <strong>grado alimenticio.</strong>],
        ['Alta resistencia a humedad y manejo intensivo.'],
        ['Control total del resultado: fabricación interna + impresión de alta definición.'],
        ['Acabados especiales: orange peel, transparente, liso brillante, high gloss, coloreable, metalizado.'],
      ],
      img: proceso4,
      imgmobile: mobileProceso4
    },
    {
      id: 5,
      nombre: 'Termoformadora Automática de Plásticos:',
      nombredesc:'Envases de gran precisión',
      icono: '',
      descripcion: '',
      txt1descripcion:[
        [<strong>Fabrica bandejas y tapas en gran cantidad </strong>,'al mismo tiempo que adaptas calidad y funcionalidad.'],
      ],
      txt2descripcion:'',
      enlistado:'¿Por qué es una gran opción?',
      caracteristicas: [
        ['Usa láminas de PET, PVC y otros termoformables.'], 
        ['Gran precisión de moldeado y diseños versátiles.'], 
        ['Solución eficiente y adaptable en un solo proceso.'],
        ['Se puede combinar con ', <strong>impresión inmold</strong>, ' para máxima durabilidad.'],
      ],
      img: proceso5,
      imgmobile: mobileProceso5
    },
  ];

const Maquinaria = () => {
  // Creamos un contenedor de refs
  const sectionRefs = useRef([]);
  
  // Estado para el botón activo
  const [activeIdx, setActiveIdx] = useState(0);
  const imagesStickyRef = useRef(null);      // mide el alto del contenedor de imágenes
  
  const [containerH, setContainerH] = useState(0);

  useEffect(() => {
    const obs = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const idx = Number(entry.target.getAttribute('data-idx'));
          // Consideramos activo cuando ~50% del bloque está visible
          if (entry.isIntersecting) setActiveIdx(idx);
        });
      },
      { threshold: 0.6, root: null }
    );

  sectionRefs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);
  useLayoutEffect(() => {
    const update = () => {
      if (imagesStickyRef.current) {
        const h = imagesStickyRef.current.getBoundingClientRect().height;
        setContainerH(h);
        //console.log(h);
    }
  };
  update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  const [stickyHeight, setStickyHeight] = useState(0);
  const stickyRef = useRef(null);

  useEffect(() => {
    if (stickyRef.current) {
      setStickyHeight(stickyRef.current.offsetHeight);
    }
    const handleResize = () => {
      if (stickyRef.current) {
        setStickyHeight(stickyRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-0">

          {/* Frase de Maquinaria */}
          <div className='container-fluid pdg-section-ch pb-md-0'>
            <div className="row align-items-center mb-5">
              <div className="col-12 text-start p-0">
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'60%'}}>
                    <span style={{ color: 'var(--color-principal)' }}>Tú necesitas etiquetas</span> que hagan más.
                </h1>
                <p className="lightblack" style={{fontWeight:'500', fontSize:'1.5rem'}}>Nosotros tenemos las máquinas especializadas para crearlas.</p>
              </div>
            </div>
          </div>

          {/* Contenido de Maquinaria*/}
          <div className='container-fluid pdg-section-ch pb-md-5' style={{background:'var(--color-text-negro-light)'}}>
            <div className="row align-items-center mb-5">
              <div className="col-lg-12 pb-3">
                <h1 className="display-4 fw-bold mb-0 tit-principal text-center">
                  <span style={{ color: 'var(--color-principal)'}}>En Mega Label, </span>
                </h1>
                <h1 className="display-4 fw-bold mb-5 tit-principal text-center">
                  <span style={{color:'white'}}> nuestros equipos nos permiten:</span>
                </h1>
              </div>
              <div className="col-lg-12 opc-producto">
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3 ps-0">
                    <div className="gray-container w-100 h-100 d-flex align-items-center p-3" 
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white'
                    }}>
                      <img src={icono1} alt="Alimentos"/>
                      <p className="fw-bold button-producto">Cumplir con los estándares más exigentes</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3 pe-0">
                    <div className="gray-container w-100 h-100 d-flex align-items-center p-3" 
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={icono2} alt="Farmacéutica"/>
                      <p className="fw-bold button-producto">Ofrecer acabados especiales y personalización</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3 ps-0">
                    <div className="gray-container w-100 h-100 d-flex align-items-center p-3"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white'
                    }}>
                      <img src={icono3} alt="Cosmética" />
                      <p className="fw-bold button-producto">Entregar volúmenes altos en corto tiempo sin comprometer calidad</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3 pe-0">
                    <div className="gray-container w-100 h-100 d-flex align-items-center p-3" 
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white'
                    }}>
                      <img src={icono4} alt="Vinos" />
                      <p className="fw-bold button-producto">Adaptarnos a lo que tu industria necesita hoy</p>
                    </div>
                  </div>     
                </div>
              </div>
            </div>
          </div>
          
          {/* Frase de maquinaria */}
          <div className='container-fluid pdg-section-ch pb-0'>
            <div className="row align-items-center mb-5">
              <div className="col-12 text-start">
                {/*
                  <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'64%'}}>
                      <span style={{ color: 'var(--color-principal)' }}>Conoce las 5 máquinas 
                    </span> que pueden darte tantas soluciones como las imagines:
                  </h1>
                */}
                <h1 className="display-4  lightblack mb-3 tit-principal" style={{width:'64%'}}>
                    <span style={{ color: 'var(--color-principal)' }}>Conoce las diferentes soluciones
                  </span> que pueden ayudarte a que tu proyecto o marca destaque.
                </h1>
              </div>
            </div>
          </div>

          {/*Contenido Maquinarias*/}
          {/*<div className='container-fluid pdg-section-scroll pb-md-auto pb-sm-5 pt-0 cont-maquinaria-scroll'>
            <div className="row mb-5 g-3">
              
              <div className="col-12 col-md-7 col-lg-8 p-0">
                {maquinas.map((maquina, idx) => (
                  <div
                    key={maquina.id}
                    data-idx={idx}
                    ref={(el) => (sectionRefs.current[idx] = el)}
                    className="pb-4 ps-md-0 cont-txt-maquinaria-scroll"
                      style={{
                        scrollMarginTop: '120px',
                        padding: '2% 2%',
                        paddingTop: '7%',
                        minHeight: stickyHeight ? `${stickyHeight}px` : "auto",
                        paddingRight: '5%',
                        borderRadius: '20px',
                        //marginTop: idx === 0 ? '0' : '9.5%',
                      }}
                  >
                  <img
                    className='d-md-none d-block '
                      key={maquina.id}
                      src={maquina.imgmobile}
                      alt={maquina.nombre}
                      style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '16px',
                        paddingBottom:'5%'
                      }}
                  />
                  
                  <h2 className={`mb-0 pb-md-2 tit-principal w-tit-principal-${maquina.id} ` }
                    style={{ 
                      color: 'var(--color-principal)'
                    }}>
                      {maquina.nombre} <span style={{color:'black'}}>{maquina.nombredesc}
                    </span>
                  </h2>
                              
                  <p style={{ margin:'0', textTransform:'uppercase' }}>{maquina.descripcion}</p>
                  
                  {maquina.txt1descripcion.map((txt1, subIdx) => (
                    <p key={subIdx}>
                      {txt1}
                    </p>
                  ))}
                  
                  <p>{maquina.txt2descripcion}</p>

                  <div className='container-fluid' 
                    style={{background:'#f5f5f5', borderRadius:'20px 20px', padding:'5% 4%', paddingBottom:'1%', marginTop:'4%' }}>
                    <p style={{color:'var(--color-principal)', fontWeight:'bold'}}> {maquina.enlistado}</p>
                    <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
                      {maquina.caracteristicas.map((caracteristica, idx2) => (
                        <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                          <img
                            src={iconoLista}
                            alt=""
                            style={{ width: '19px', height: 'auto', marginRight: '5px'}}
                            aria-hidden="true"
                          />
                          <p className='m-0'>  
                            {Array.isArray(caracteristica) ? caracteristica : caracteristica}  
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="col-12 col-md-5 col-lg-4 ps-0 ps-md-2 pe-md-0"> 
              <div className='container-fluid d-md-block d-none'
                style={{
                  width:'100%',
                  height: '100%'
                }}
              >
                
                {maquinas.map((maquina, idx) => (
                <div
                  className='cont-imgscrolly'
                  key={maquina.id}
                  ref={imagesStickyRef}
                    style={{
                    position: "sticky",
                    //top: "0%",       // se queda fijo a partir de este punto
                    //height: "100vh",   // mismo alto que la columna izquierda
                    

                    height: 
                      idx < activeIdx
                        ? '78vh'    // las anteriores se encogen y suben un poco
                        : idx === activeIdx
                        ? '78vh'   // la activa se muestra normal(se va mostrando el nuevo)
                        : '100vh',  // las siguientes esperan abajo
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  
                  <img
                    key={maquina.id}
                    className='img-scrolly'
                    src={maquina.img}
                    alt={maquina.nombre}
                    style={{
                      position: "absolute",
                      inset: 0,
                      //width: 'auto',
                      
                      objectFit: 'contain',
                      zIndex: idx,
                      //opacity: idx === activeIdx ? 1 : 0, // solo activa visible
                      //transform: 'translateY(0) scale(1)',
                      transition: 'transform 0.2s linear', // suave cuando cambia activeIdx
                      //transition: 'transform',
                      borderRadius: '16px',
                      transform:
                        idx < activeIdx
                          ? "translateY(0%) scale(1)"     // translateY(-5%) scale(1)  las anteriores se encogen y suben un poco
                          : idx === activeIdx
                          ? "translateY(0%) scale(1)"    // la activa se muestra normal(se va mostrando el nuevo)
                          : "translateY(24%) scale(1)",  // translateY(35%) scale(1) las siguientes esperan abajo
                    }}
                  />
                </div>      
                ))}
              </div>
            </div>
          </div>
        </div>*/}
        {/**Final de contenido maquinaria */}

        {/**Contenido de prueba para maquinaria*/}
        <div className='container-fluid pdg-section-scroll pb-md-auto pb-sm-5 pt-0 cont-maquinaria-scroll'>
            <div className="row mb-5 g-3">
              {/* Contenido de cada industria */}
              <div className="col-12 col-md-7 col-lg-8 p-0">
                {maquinas.map((maquina, idx) => (
                  <div
                    key={maquina.id}
                    data-idx={idx}
                    ref={(el) => (sectionRefs.current[idx] = el)}
                    className="pb-4 ps-md-0 cont-txt-maquinaria-scroll"
                      style={{
                        scrollMarginTop: '120px',
                        padding: '2% 2%',
                        paddingTop: '7%',
                        minHeight: stickyHeight ? `${stickyHeight}px` : "auto",
                        paddingRight: '5%',
                        borderRadius: '20px',
                        //marginTop: idx === 0 ? '0' : '9.5%',
                      }}
                  >
                  <img
                    className='d-md-none d-block '
                      key={maquina.id}
                      src={maquina.imgmobile}
                      alt={maquina.nombre}
                      style={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '16px',
                        paddingBottom:'5%'
                      }}
                  />
                  {/**
                   * className="mb-0 pb-md-2 tit-principal " 
                   */}
                  <h2 className={`mb-0 pb-md-2 tit-principal w-tit-principal-${maquina.id} ` }
                    style={{ 
                      color: 'var(--color-principal)'
                    }}>
                      {maquina.nombre} <span style={{color:'black'}}>{maquina.nombredesc}
                    </span>
                  </h2>
                              
                  <p style={{ margin:'0', textTransform:'uppercase' }}>{maquina.descripcion}</p>
                  {/*<p >{maquina.txt1descripcion}</p>*/}
                  {maquina.txt1descripcion.map((txt1, subIdx) => (
                    <p key={subIdx}>
                      {txt1}
                    </p>
                  ))}
                  
                  <p>{maquina.txt2descripcion}</p>

                  <div className='container-fluid' 
                    style={{background:'#f5f5f5', borderRadius:'20px 20px', padding:'5% 4%', paddingBottom:'1%', marginTop:'4%' }}>
                    <p style={{color:'var(--color-principal)', fontWeight:'bold'}}> {maquina.enlistado}</p>
                    <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
                      {maquina.caracteristicas.map((caracteristica, idx2) => (
                        <li key={idx2} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '8px' }}>
                          <img
                            src={iconoLista}
                            alt=""
                            style={{ width: '19px', height: 'auto', marginRight: '5px'}}
                            aria-hidden="true"
                          />
                          <p className='m-0'>  
                            {Array.isArray(caracteristica) ? caracteristica : caracteristica}  
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
            {/**Contenedor de imagenes de maquinaria */}
            <div className="col-12 col-md-5 col-lg-4 ps-0 ps-md-2 pe-md-0"> 
              <div className='container-fluid d-md-block d-none'
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'relative'
                }}
              >
                {/**
                 * 
                 top: 
                      idx < activeIdx
                        ? '7%'    // las anteriores se encogen y suben un poco
                        : idx === activeIdx
                        ? '7%'   // la activa se muestra normal(se va mostrando el nuevo)
                        : '0%'  // las siguientes esperan abajo
                      || activeIdx === '5'
                        ? '-2%'
                        : '',
                 * 
                 */}
                {maquinas.map((maquina, idx) => (
                <div
                  className='cont-imgscrolly'
                  key={maquina.id}
                  ref={imagesStickyRef}
                  style={{
                    position: "sticky",
                    top: "10%",    // margen superior fijo
                    height: "70vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                    /*style={{
                    position: "sticky",
                    //top: "10%",       // se queda fijo a partir de este punto
                    //height: "100vh",   // mismo alto que la columna izquierda
                    
                    top: 
                      idx < activeIdx
                        ? '7%'    // las anteriores se encogen y suben un poco
                        : idx === activeIdx
                        ? '7%'   // la activa se muestra normal(se va mostrando el nuevo)
                        : '0%'  // las siguientes esperan abajo
                      || activeIdx === '5'
                        ? '-2%'
                        : '',
                    height: 
                      idx < activeIdx
                        ? '78vh'    // las anteriores se encogen y suben un poco
                        : idx === activeIdx
                        ? '78vh'   // la activa se muestra normal(se va mostrando el nuevo)
                        : '100vh',  // las siguientes esperan abajo
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}*/
                >
                  {/* 
                  height:
                        idx < activeIdx
                          ? '115%'    // translateY(-5%) scale(1)  las anteriores se encogen y suben un poco
                          : idx === activeIdx
                          ? '115%'  //115% la activa se muestra normal(se va mostrando el nuevo)
                          : '90%',  // las siguientes esperan abajo
                  */}
                  <img
                    key={maquina.id}
                    className='img-scrolly'
                    src={maquina.img}
                    alt={maquina.nombre}
                    /*style={{
                      position: "absolute",
                      inset: 0,
                      //width: 'auto',
                      
                      objectFit: 'contain',
                      zIndex: idx,
                      //opacity: idx === activeIdx ? 1 : 0, // solo activa visible
                      //transform: 'translateY(0) scale(1)',
                      transition: 'transform 0.2s linear', // suave cuando cambia activeIdx
                      //transition: 'transform',
                      borderRadius: '16px',
                      transform:
                        idx < activeIdx
                          ? "translateY(0%) scale(1)"     // translateY(-5%) scale(1)  las anteriores se encogen y suben un poco
                          : idx === activeIdx
                          ? "translateY(0%) scale(1)"    // la activa se muestra normal(se va mostrando el nuevo)
                          : "translateY(35%) scale(1)",  // translateY(35%) scale(1) las siguientes esperan abajo
                    }}*/
                  
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      borderRadius: "16px",
                      opacity: idx === activeIdx ? 1 : 0,   // solo activa visible */
                      transition: "opacity 0.6s ease-in-out"
                    }}
                  />
                  {/**opacity: idx === activeIdx ? 1 : 0,   // solo activa visible */}
                </div>      
                ))}
              </div>
            </div>
          </div>
        </div>
        {/**Final de contenedor de maquinaria */}

        {/* Segunda frase de Maquinaria*/}
        <div className='container-fluid pdg-section-ch' style={{background:'var(--color-text-negro-light)'}}>
          <div className="row align-items-center mb-5">
            <div className="col-lg-12">
              <h1 className="display-4 mb-4 tit-principal">
                <span style={{ color: 'var(--color-principal)'}}>Somos los mejores haciendo etiquetas.
                </span> <span style={{color:'white'}}>Somos etiquetas que hacen más.</span>
              </h1>
              <p className="lightblack mb-4" style={{color:'white'}}>
                      ¿No encontraste lo que buscas? Escríbenos directamente, un especialista comercial puede ayudarte a diseñar la mejor solución.
              </p>
              <a href="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom p-3 mt-3">
                Contacta con nosotros
              </a>                          
            </div>                       
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Maquinaria; 